import { Skill } from 'types/Skill';

export const extractSkillsFromPrevStates = (
  items: { tagIds: string[]; mainTechnologyIds?: string[] }[],
  skillWeights: Skill[] = [],
): Skill[] =>
  [
    ...new Set(
      items
        .map(({ tagIds, mainTechnologyIds }) => [...(mainTechnologyIds ?? []), ...tagIds])
        .flat(),
    ),
  ].map((id) => {
    const alreadyExists = skillWeights.find(({ tagId }) => tagId === id);
    return {
      tagId: id,
      weight: alreadyExists?.weight || 1,
    };
  });
